export const clearAllCacheBeforeLogin = () => {
  const WIDGET_KEY = "widgetSettings"; // change to your actual key

  // Save widget setting before clearing
  const widgetData = localStorage.getItem(WIDGET_KEY);

  // Clear app storage
  localStorage.clear();
  sessionStorage.clear();

  // Clear i18n cache
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("i18next")) {
      localStorage.removeItem(key);
    }
  });

  if (widgetData !== null) {
    localStorage.setItem(WIDGET_KEY, widgetData);
  }
};

